import React from "react";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
// html-react-parser import removed: parse() was imported but never called in this file
import TableEmptyState from "Components/Common/Table/TableEmptyState";
import TableLoadMore from "Components/Common/Table/TableLoadMore";
import TableCellLoader from "Components/Common/Table/TableCellLoader";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
const useStyle = makeStyles((theme) => ({
  tableHead: {
    "&>tr": {
      "&>th": {
        "&:first-child": {
          width: "100px",
          [theme.breakpoints.down(1500)]: {
            width: "16%",
          },
          [theme.breakpoints.up("lg")]: {
            width: "21%",
          },
          [theme.breakpoints.up("xl")]: {
            width: "24%",
          },
        },
        "&:nth-child(3)": {
          width: "20% !important",
        },
        "&:last-child": {
          whiteSpace: "nowrap !important",
        },
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        lineHeight: "3",

        [theme.breakpoints.down(431)]: {
          minWidth: "170px",
        },
      },
    },
  },
}));

/** header cell title */
const headCells = [
  {
    id: "ps_payment_status",
    label: "PAYMENT STATUS",
    // sortable: true,
  },
  {
    id: "ps_status",
    label: "CURRENT STATUS",
    // sortable: true,
  },
  {
    id: "ps_subscription_start",
    label: "START DATE",
    // sortable: true,
  },
  {
    id: "ps_subscription_end",
    label: "END DATE",
    // sortable: true,
  },
  {
    id: "invoice_file",
    label: " INVOICE",
    // sortable: true,
  },
];

const PaymentLogTable = ({
  columnSortingOrder,
  defaultColumnOrderBy,
  setColumnSortingOrder,
  activityList,
  setTarget,
  link,
  setLink,
  openInvoice,
  setOpenInvoice,
}) => {
  const classes = useStyle();
  return (
    <Grid className="common-table">
      <TableContainer>
        <Table stickyHeader>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {headCells.map((headCell) => (
                <>
                  {headCell.sortable === true ? (
                    <TableCell
                      key={headCell.id}
                      align="center"
                      whiteSpace="nowrap"
                      padding={headCell.disablePadding ? "none" : "normal"}
                    >
                      <TableSortLabel
                        sx={{
                          "&.MuiTableSortLabel-root": {
                            color: "white",
                          },
                          "& .MuiTableSortLabel-icon": {
                            color:
                              columnSortingOrder.orderBy === headCell.id
                                ? "#525252 !important"
                                : "#C5C5C5 !important",
                            "&.MuiTableSortLabel-iconDirectionDesc": {
                              color: "#525252 !important",
                            },
                            "& .MuiTableSortLabel-iconDirectionAsc": {
                              color:
                                columnSortingOrder.orderBy === headCell.id
                                  ? "#525252 !important"
                                  : "#C5C5C5 !important",
                            },
                          },
                        }}
                        className="tableSort"
                        direction={
                          columnSortingOrder.orderBy === headCell.id
                            ? columnSortingOrder.sortBy
                            : defaultColumnOrderBy
                        }
                        onClick={(e) => {
                          setColumnSortingOrder({
                            orderBy: headCell.id,
                            sortBy:
                              (columnSortingOrder.orderBy === headCell.id
                                ? columnSortingOrder.sortBy
                                : defaultColumnOrderBy) === "desc"
                                ? "asc"
                                : "desc",
                          });
                        }}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ) : (
                    <TableCell> {headCell.label}</TableCell>
                  )}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {activityList?.loading ? (
              <TableCellLoader cells={5} />
            ) : activityList?.data?.data?.list?.length > 0 ? (
              activityList?.data?.data?.list?.map((item, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>{item.ps_payment_status}</TableCell>
                    <TableCell>{item.ps_status}</TableCell>
                    <TableCell>
                      {moment(new Date(item.ps_subscription_start)).format(
                        "DD-MM-YYYY"
                      ) || "N / A"}
                      &nbsp;
                      {moment(
                        new Date(item?.ps_subscription_start),
                        "hh:mm A"
                      ).format("HH:mm")}
                    </TableCell>
                    <TableCell>
                      {moment(new Date(item.ps_subscription_end)).format(
                        "DD-MM-YYYY"
                      ) || "N / A"}
                      &nbsp;
                      {moment(
                        new Date(item?.ps_subscription_end),
                        "hh:mm A"
                      ).format("HH:mm")}
                    </TableCell>
                    <TableCell>
                      {item?.invoice_file ? (
                        <IconButton
                          onClick={() => {
                            setOpenInvoice(true);
                            setLink(item?.invoice_file);
                          }}
                        >
                          <RemoveRedEyeIcon />
                        </IconButton>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableEmptyState />
            )}
            {activityList?.data?.list?.length !==
              activityList?.data?.filterd_record && (
              <TableLoadMore setRef={setTarget} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default PaymentLogTable;
